import { render, staticRenderFns } from "./claimsEdit.vue?vue&type=template&id=5350d72e&"
import script from "./claimsEdit.vue?vue&type=script&lang=js&"
export * from "./claimsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports